import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { DateTime, Settings as LuxonSettings } from "luxon";

/**
 * AdapterLuxon wrapper that prevents LuxonSettings.throwOnInvalid from breaking
 * MUI X DatePicker's internal parsing of incomplete/partial date input.
 *
 * When throwOnInvalid=true, Luxon throws InvalidDateTimeError for unparseable
 * strings (e.g. placeholder values like "NaN NaN 0004"). MUI X's updateSectionValue
 * calls setSelectedSections before getDateFromDateSections, so the throw causes
 * focus to advance without saving the section value — resulting in "1.1.1" behavior.
 *
 * AdapterLuxon.parse is an arrow function class field, not a prototype method,
 * so it cannot be called via super. We redefine it as a class field that
 * temporarily disables throwOnInvalid, then restores it.
 */
export class AdapterLuxonSafe extends AdapterLuxon {
  // Arrow function field — overrides the parent's arrow function field.
  // eslint-disable-next-line @typescript-eslint/class-literal-property-style
  override parse = (
    value: string,
    formatString: string,
  ): DateTime<true> | DateTime<false> | null => {
    if (value === "") {
      return null;
    }
    const settings = LuxonSettings as any;
    const prev = settings.throwOnInvalid;
    settings.throwOnInvalid = false;
    try {
      return DateTime.fromFormat(value, formatString, { locale: this.locale });
    } finally {
      settings.throwOnInvalid = prev;
    }
  };
}
